import cssifyObject from 'css-in-js-utils/lib/cssifyObject';

export default function cssifyFontFace(fontFace) {
  return '@font-face{' + cssifyObject(fontFace) + '}';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/node_modules/fela-utils/es/cssifyFontFace.js
// module id = 761
// module chunks = 0